module.exports = __webpack_public_path__ + "img/IMG_0374_L_WoodMatted.880cdea8.jpg";